module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABBCAMAAAAQXfHjAAAARVBMVEUAU6UAVKQOWpwOW5vFsibFsSXIiyrIiinOPTDOPDAAU6UOWZwPWpseYZIqZ4orZ4nSEDTlYB/pbxruhhTxkRHznA7/zgCov8/BAAAACnRSTlOztLa36Ont7vj5thxuzgAAAHdJREFUeNrt1kkKgDAMQNE4z1rH+x9VHMBNaWmhIvj/Lqu3SohEtaluO5rV1XpOtWsCAgICAgICAuKPJK2pQYO0rsWSbfYexKsU5INIsdgbb2RavMqlUsErQUDCIa/sCbfrr0jSmOo1SONazN8FAgICAgIC8m1kB7HVX85B0T1YAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/ax.png
// module id = iPnz
// module chunks = 0